import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { watchProgressAPI } from '../services/api';
import { Play, X } from 'lucide-react';

const ContinueWatchingRow = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadContinueWatching();
  }, []);

  const loadContinueWatching = async () => {
    try {
      const response = await watchProgressAPI.getContinueWatching();
      // Filter out music videos - they always start from the beginning
      const filteredItems = response.data.filter(item => item.content_type !== 'music_video');
      setItems(filteredItems);
    } catch (error) {
      console.error('Error loading continue watching:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (e, contentId) => {
    e.stopPropagation();
    try {
      await watchProgressAPI.remove(contentId);
      setItems(items.filter(item => item.id !== contentId));
    } catch (error) {
      console.error('Error removing item:', error);
    }
  };

  if (loading || items.length === 0) return null;

  return (
    <div className="mb-8" data-testid="continue-watching-row">
      <h2 className="text-2xl font-bold text-foreground mb-4 px-4 md:px-8">Continue Watching</h2>
      
      <div className="flex overflow-x-auto scrollbar-hide space-x-4 px-4 md:px-8 pb-4">
        {items.map((item) => (
          <div
            key={item.id}
            className="flex-shrink-0 w-64 cursor-pointer group"
            onClick={() => navigate(`/content/${item.id}`)}
          >
            <div className="relative aspect-video rounded-xl overflow-hidden bg-card border border-border/50">
              <img
                src={item.thumbnail}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              
              {/* Progress Bar */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/20">
                <div
                  className="h-full bg-electric"
                  style={{ width: `${item.watch_progress.percentage}%` }}
                />
              </div>

              {/* Play Overlay */}
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                <div className="w-16 h-16 rounded-full bg-electric/90 flex items-center justify-center">
                  <Play className="h-8 w-8 text-background fill-background" />
                </div>
              </div>

              {/* Remove Button */}
              <button
                onClick={(e) => handleRemove(e, item.id)}
                className="absolute top-2 right-2 w-8 h-8 rounded-full bg-black/80 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black"
              >
                <X className="h-4 w-4 text-white" />
              </button>
            </div>
            
            <div className="mt-2">
              <h3 className="font-semibold text-foreground line-clamp-1">{item.title}</h3>
              <p className="text-sm text-foreground/60">
                {Math.round(item.watch_progress.percentage)}% watched
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContinueWatchingRow;
